import { Alert, AlertTitle } from "@material-ui/lab";
import React from "react";
import { useField } from "react-final-form";

const RouteOptimisationConstraintAlert = () => {
  const desiredRouteDurationField = useField("desiredRouteDuration");
  const maxVehicleCapacityField = useField("maxVehicleCapacity");
  const maxStopTimeField = useField("maxStopTime");

  return (
    <>
      <Alert severity="info">
        <AlertTitle>Info</AlertTitle>
        Current route optimisation constraints:
        <ul style={{ fontWeight: 600, margin: 5 }}>
          <li>
            Maximum vehicle capacity: {maxVehicleCapacityField.input.value}
          </li>
          <li>Maximum stop time: {maxStopTimeField.input.value} m</li>
          <li>
            Desired route duration: {desiredRouteDurationField.input.value} m
          </li>
        </ul>
      </Alert>
    </>
  );
};

export default RouteOptimisationConstraintAlert;
